import React from 'react';
import { CountryFlag } from '@fourthwall/components';
import { formatChartValue } from '../../pages/AnalyticsReport/hooks/utils/formatChartValue';
import { useAnalyticsContext } from '../../providers/AnalyticsProvider';
import { useAnalyticsReportQuery } from '../../queries/useAnalyticsReportQuery';
import { useAnalyticsCardLegend } from '../useAnalyticsCardLegend';
import { useAnalyticsQueryParams } from '../useAnalyticsQueryParams';
import { useReportLink } from '../useReportLink';
const reportId = 'sales_by_country';
export const useSalesByCountryReportCard = () => {
    const { isLoading: isReportDefinitionLoading, getReportDefinition } = useAnalyticsContext();
    const analyticsQueryParams = useAnalyticsQueryParams();
    const reportLink = useReportLink(reportId);
    const reportDefinition = getReportDefinition(reportId);
    const { analyticsReportQuery } = useAnalyticsReportQuery([{ id: reportId }, analyticsQueryParams]);
    const legend = useAnalyticsCardLegend();
    const activeColumn = reportDefinition?.columns.find((column) => column.key === reportDefinition?.yAxisDefaultValue);
    const reportData = analyticsReportQuery?.data;
    const data = reportData?.report?.rows?.slice(0, 8).map((rowData) => {
        const data = rowData;
        return {
            label: React.createElement(CountryFlag, { countryCode: data.country }),
            value: data.income.value,
        };
    });
    return {
        header: {
            label: reportDefinition?.name || '',
            tooltip: activeColumn?.tooltip,
        },
        type: 'stats',
        isLoading: isReportDefinitionLoading || analyticsReportQuery.isLoading,
        reportLink,
        legend,
        emptyMessage: 'No data found in this date range',
        data,
        formatValue: (value) => formatChartValue(value, activeColumn?.type),
    };
};
